/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type EvaluateBadRequestErrorCode = (typeof EvaluateBadRequestErrorCode)[keyof typeof EvaluateBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluateBadRequestErrorCode = {
  no_answers: "no_answers",
  action_locked: "action_locked",
  evaluation_reason_required: "evaluation_reason_required",
} as const;
